import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=138bc22c&scoped=true&"
import script from "./PDFViewer.vue?vue&type=script&lang=js&"
export * from "./PDFViewer.vue?vue&type=script&lang=js&"
import style0 from "./PDFViewer.vue?vue&type=style&index=0&id=138bc22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138bc22c",
  null
  
)

export default component.exports